











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'AutoApprovalLoadingIndicator'
})
export default class AutoApprovalLoadingIndicator extends Vue {
  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop({ type: String, default: '' })
  loadingText!: string;
}
